let htmlDecodeTextarea: HTMLTextAreaElement | null = null;

export function decodeHtmlEntities(value: string | null | undefined): string {
  if (value == null) {
    return '';
  }

  const stringValue = String(value);
  if (!stringValue) {
    return stringValue;
  }

  if (typeof window === 'undefined') {
    return stringValue;
  }

  if (!htmlDecodeTextarea) {
    htmlDecodeTextarea = document.createElement('textarea');
  }

  htmlDecodeTextarea.innerHTML = stringValue;
  const decoded = htmlDecodeTextarea.value;
  htmlDecodeTextarea.innerHTML = '';

  return decoded || stringValue;
}
